/* Flag — renders a country flag using flagcdn.com SVG so deployed Linux
   environments don't fall back to plain text (Linux containers often lack the
   color-emoji font that turns 🇳🇱 into the Dutch flag glyph). The img is
   intrinsically sized via the height prop; aspect ratio is preserved. */
import React from "react";

const FLAG_BASE = "https://flagcdn.com";

// A handful of overrides for cases where the persona uses a non-ISO label
// (e.g. "Brasil" vs "br"). Maps ALWAYS to a flagcdn-supported 2-letter code.
const ALIAS = {
  UK: "gb",
};

export default function Flag({
  code,
  height = 14,
  className = "",
  rounded = true,
  title,
  testid,
}) {
  if (!code) {
    return (
      <span
        aria-hidden="true"
        className={`inline-block bg-slate-200 ${rounded ? "rounded-sm" : ""} ${className}`}
        style={{ height, width: Math.round(height * 1.5) }}
      />
    );
  }
  const cc = (ALIAS[code.toUpperCase()] || code).toLowerCase();
  const src1x = `${FLAG_BASE}/${cc}.svg`;
  return (
    <img
      src={src1x}
      alt={title || code}
      title={title || code}
      data-testid={testid}
      style={{ height, width: "auto", display: "inline-block" }}
      className={`shrink-0 object-contain ${rounded ? "rounded-[2px]" : ""} ${className}`}
      loading="lazy"
      onError={(e) => {
        // Hide gracefully if the CDN ever fails; the surrounding label still
        // shows the country code so the UI stays legible.
        e.currentTarget.style.visibility = "hidden";
      }}
    />
  );
}
